import React, {  lazy, Suspense } from "react";
import './App.css';


const Navbar = lazy(() =>
  import("./components/Navbar")
);
const Header = lazy(() =>
  import("./components/Header")
);
const Body = lazy(() =>
  import("./components/Body")
);
const Contact = lazy(() =>
  import("./components/ContactUs")
);
const SubFooter = lazy(() =>
  import("./components/SubFooter")
);
const Footer = lazy(() =>
  import("./components/Footer")
);

function App() {


  return (
    <>
    <Suspense fallback={<div />}>
    <Navbar/>
    </Suspense>
    <Suspense fallback={<div />}>
      <Header />
      </Suspense>
      <Suspense fallback={<div />}>
      <Body />
      </Suspense>
      <Suspense fallback={<div />}>
      <Contact />
      </Suspense>
      <Suspense fallback={<div />}>
      <SubFooter />
      </Suspense>
      <Suspense fallback={<div />}>
      <Footer />
      </Suspense>
    </>
  );
}

export default App;
